export default "__VITE_ASSET__84895683__"